import { schoolFunction } from '@/config.json';
const state = {
  schoolInfo: {
    exist: null,
    name: ''
  }
};
const getters = {
  schoolExist(state) {
    return state.schoolInfo.exist;
  },
  schoolName(state) {
    return state.schoolInfo.name;
  }
};

const mutations = {
  updateSchool(state, payload) {
    state.schoolInfo.exist = payload.exist;
    state.schoolInfo.name = payload.name;
  }
};

const actions = {
  async getSchoolInfo({ commit }) {
    try {
      let res = await fetch(schoolFunction);
      let data = await res.json();
      commit('updateSchool', {
        exist: data.exist,
        name: data.school
      });
    } catch (e) {
      // eslint-disable-next-line
      console.log(e);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
